<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'workgroup',
})
</script>
<template>
  <a-card title="工作组">
    <template #extra>
      <a-button type="primary" @click="onAdd">
      <PlusOutlined /> 创建
    </a-button>
    </template>
    <a-collapse v-model:activeKey="activeKey" :destroyInactivePanel="true" collapsible="icon" :accordion="true" :ghost="true" @change="showUsers">
      <a-collapse-panel :key="it.ID" v-for="(it,i) in dataSource">
        <template #header>
          <div class="flex align-center">
                    <div class="flex1 flex align-center">
                      <a-avatar size="small" class="margin-right" :src="it.icon?addip(it.icon):'/account/levelOneDept.png'" />
                       <span class="margin-right-sm">{{it.title }}</span>
                       <span class="text-gray">{{it.retime }}</span>
                  </div>
                    <div class="flex align-center " :class="actID==it.ID?'text-primary':'text-gray'">
                    <template v-if="it.type==true" >
                      <a-popconfirm
                        title="确定要解散此工作组吗?"
                        @confirm="del(it,i)"
                      >
                      <CloseOutlined class="text-lg  padding-lr" />
                      </a-popconfirm>
                      <a-tooltip title="添加成员">
                        <UserAddOutlined @click="toFind" class="text-lg  padding-lr" />
                      </a-tooltip>

                    </template>

                      <a-popconfirm v-else
                        title="确定要退出此工作组吗?"
                        @confirm="del(it,i)"
                      >
                       <CloseOutlined class="text-lg padding-lr" />
                      </a-popconfirm>
                      <a-tooltip title="工作组通讯">
                      <MessageOutlined class="text-lg  padding-lr" @click="onOpenMqtt(it.ID)" />
                      </a-tooltip>
                      </div>
            </div>
        </template>
        <a-list class="bg-gray-light padding radius"  rowKey="ID" item-layout="horizontal" :data-source="userList">
          <template #header>
            <div class="flex align-center">
                共  <a-badge class="margin-lr-sm" :count="userList.length"></a-badge>  个成员
            </div>
          </template>
          <template #renderItem="{ item,index }">
            <a-list-item >
                  <template #actions>
                    <a-popconfirm
                        title="是否确定删除此成员?"
                        @confirm="delUser(item,index)"
                      >
                    <CloseOutlined />
                  </a-popconfirm>
                  </template>
                  <a-list-item-meta class="pointer" :description="item.retime">
                    <template #title>
                      <span>{{ item.username }}</span>
                    </template>
                    <template #avatar>
                      <a-avatar :src="item.pic?addip(item.pic):'/account/levelOneDept.png'" />
                    </template>
                  </a-list-item-meta>
                </a-list-item>
              </template>
            </a-list>
      </a-collapse-panel>
    </a-collapse>
    <lanseed-form :mode="true" v-model:open="edit" :data="model" :rules="rules" @change="infoChange"></lanseed-form>
    <finduser v-model:open="openfind" mode="muti" @change="userSelected"></finduser>
    <mqttMessage ref="mqttClient"></mqttMessage>
  </a-card>
</template>
<script setup lang="ts" name="workgroup">
  import {PlusOutlined,CloseOutlined,UsergroupAddOutlined,UserAddOutlined,MessageOutlined,RightOutlined}  from '@ant-design/icons-vue'
  import api from '@/utils/http/service'
  import { onMounted, reactive,ref } from 'vue'
  import {addip} from '@/utils/util'
  import ls from '@/utils/Storage'
  import { USER_INFO } from '@/store/mutation-types'
  import LanseedForm from '@/components/lanseed/form.vue'
  import finduser from './finduser.vue'
  import {message} from 'ant-design-vue'
  import mqttMessage from './mqttMessage.vue'

  const dataSource =ref<Array>([])
  const userList=ref<Array<any>>([])
  const edit=ref<boolean>(false)
  const openfind=ref<boolean>(false)
  const model=ref<any>({})
  const actID=ref<Number|null>(null)
  const topic=ref<String>('')
  const uid=ref<String>('')
  const activeKey=ref<Array>([])
  const openmqtt=ref<boolean>(false)
  const rules=ref<any>({
      title:{required:true,name:'名称'},
      icon:{domtype:'img', name:'图标'}
    })
  const mqttClient=ref()
    onMounted(()=>{
      api.workgroup.list().then(e=>{
        if(e.state==1){
          const {userid}=ls.get(USER_INFO)
          uid.value=userid
          e.data.map(f=>{
            if(f.userid===userid){
              f['type']=true //说明是自己创建的
            }
          })
          dataSource.value=e.data
        }
      })
    })
    const groupChange=(e)=>{
      console.info('----',e)
    }
  const showUsers=(id:Number)=>{
    if(!id){return false}
    actID.value=id
    topic.value='wordgroup_'+id
    api.workgroup.userlist(id).then(res=>{
      if(res.state==1){
        userList.value=res.data
      }
    })
  }
  const onAdd=()=>{
    model.value={ID:0,title:'',icon:'',no:'',path:''}
    edit.value=true
  }
  const infoChange=(e)=>{
    api.workgroup.add(e).then(res=>{
      if(res.state==1){
        dataSource.value.unshift(res.data)
        edit.value=false
      }
    })
  }
  const delUser=(item:any,index:number)=>{
    api.workgroup.deluser(actID.value,item.userid).then(res=>{
      if(res.state==1){
         userList.value.splice(index,1)
      }
    })
  }
  const del=(item:any,index:number)=>{
    api.workgroup.del(item.ID).then(res=>{
      if(res.state==1){
         dataSource.value.splice(index,1)
      }
    })
  }
  const userSelected=(e:any)=>{
    let ids=''
    if(typeof(e)=='object'){
      ids=e.join(',')
    }else{
      ids=e
    }
    api.workgroup.adduser(actID.value,ids).then(res=>{
      if(res.state==1){
        userList.value=userList.value.concat(res.data)
        message.success('成员添加成功')
      }
    })
  }
  const toFind=()=>{
    openfind.value=true
  }
  const onOpenMqtt=(id:Number):void=>{
    if(uid.value){
      mqttClient.value.open('workgroup_'+id,uid.value)
    }else{
      message.info('用户ID未知')
    }
  }
</script>
<style lang="less">
  .ant-collapse-header.ant-collapse-icon-collapsible-only{display:flex;align-items:center;justify-content:center;}
</style>
